module.exports = __webpack_public_path__ + "static/img/jumper_ff-1.481acf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/jumper_ff-1.svg
// module id = k8SP
// module chunks = 0